<template>
  <v-container>
    <v-container>
      <v-card tile>
        <v-card-title>{{ $t("locationSchedulesAndPlaygrounds") }}</v-card-title>
        <v-container>
          <playground-group
            v-for="group in location.playground_groups"
            :key="group.id"
            :group="group"
          ></playground-group>
          <v-card tile>
            <v-card-title>{{ $t("playgroundNoGroup") }}</v-card-title>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left blue--text" width="5%">#</th>
                    <th class="text-left blue--text">
                      {{ $t("playgroundName") }}
                    </th>
                    <th class="text-left blue--text" width="15%">
                      {{ $t("playgroundType") }}
                    </th>
                    <th class="text-left blue--text" width="35%">
                      {{ $t("playgroundDuration") }}
                    </th>
                  </tr>
                </thead>
                <draggable
                  :list="noGroupPlaygrounds"
                  group="playgrounds"
                  tag="tbody"
                  @end="onEnd"
                  :empty-insert-threshold="50"
                >
                  <tr
                    v-for="(playgroundId, k) in noGroupPlaygrounds"
                    :key="k"
                    :playgroundId="playgroundId"
                  >
                    <td>{{ k + 1 }}</td>
                    <td>
                      {{
                        location.playgrounds.find((el) => {
                          return el.id == playgroundId;
                        }).name
                      }}
                    </td>
                    <td>
                      {{
                        location.playgrounds.find((el) => {
                          return el.id == playgroundId;
                        }).types
                      }}
                    </td>
                    <td>
                      {{
                        location.playgrounds.find((el) => {
                          return el.id == playgroundId;
                        }).duration +
                        " " +
                        $t("playgroundMin")
                      }}.
                    </td>
                  </tr>
                </draggable>
              </template>
            </v-simple-table>
          </v-card>
          <v-dialog v-model="dialogCreateGroup" persistent max-width="800px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" class="mt-4">{{
                $t("playgroundAdd")
              }}</v-btn>
            </template>
            <v-card tile>
              <v-card-title>
                <span class="headline">{{ $t("playgroundNew") }}</span>
              </v-card-title>
              <v-card-text>
                <v-text-field
                  :label="$t('playgroundGroup') + '*'"
                  name="group"
                  type="text"
                  required
                  v-model="newGroup.name"
                  :error-messages="groupNameErrors"
                  @input="$v.newGroup.name.$touch()"
                  @blur="$v.newGroup.name.$touch()"
                ></v-text-field>
                <small>* {{ $t("validation") }}</small>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="green darken-1"
                  text
                  @click="createGroup(newGroup), (dialogCreateGroup = false)"
                  :disabled="$v.$invalid"
                  >{{ $t("btnCreate") }}</v-btn
                >
                <v-btn
                  color="red darken-1"
                  text
                  @click="dialogCreateGroup = false"
                  >{{ $t("btnCancel") }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>
      </v-card>
    </v-container>
  </v-container>
</template>

<script>
import PlaygroundGroup from "@/components/PlaygroundGroup.vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapGetters, mapActions } from "vuex";
import draggable from "vuedraggable";
import store from "../../store";

export default {
  name: "SchedulesAndPlaygrounds",

  beforeRouteEnter: async (to, from, next) => {
    await store.dispatch("loadLocation", to.params.location_id);
    await store.dispatch("loadLocationSchedules", to.params.location_id);
    next();
  },

  mixins: [validationMixin],

  data() {
    return {
      dialogCreateGroup: false,
      newGroup: {
        name: "",
      },
    };
  },

  computed: {
    ...mapGetters(["location"]),
    noGroupPlaygrounds: function () {
      let noGroupArr = this.location.playgrounds.filter((el) => {
        return el.group == null;
      });

      return noGroupArr.map((el) => {
        return el.id;
      });
    },
    groupNameErrors() {
      const errors = [];
      if (!this.$v.newGroup.name.$dirty) return errors;
      !this.$v.newGroup.name.required &&
        errors.push(this.$i18n.t("validationGroupName"));
      return errors;
    },
  },

  components: {
    PlaygroundGroup,
    draggable,
  },

  validations: {
    newGroup: {
      name: {
        required,
      },
    },
  },

  methods: {
    ...mapActions(["createGroup", "changePlaygroundGroup"]),
    onEnd(evt) {
      // D&D
      this.changePlaygroundGroup({
        playgroundId: evt.clone.attributes.playgroundId.value,
        groupId: evt.to.id,
      });
    },
  },
};
</script>
